import './scss/index.scss';
import './utils/utils';
import 'tocca';

import LeaderBoard from './js/leaderboard.js'
import MainGame from './js/mainGame.js'
import bodymovin from 'lottie-web'

import {muteAll,moveSound,fallingSound,rotateSound,matchPairSound,frezzeCellSound,gamePlayMusic, titleScreenMusic} from './js/audioManager.js'
import { isMobile, isIOS } from './utils/utils';

const LB = new LeaderBoard();
let time = Date.now();
let timer_time = Date.now();
let frame = 0;
let gameSpeed = 900; //duration of cycle in ms.
let storedProducts = 6;
const width = 7;
const STAGE_HEIGHT= 13;
const domMatrix =  Array(width*STAGE_HEIGHT).fill([0,'clear']);

let firstTime = true;
let submited = false;
let runnedOutOfTime = false;

// score variables
let matchesArray = [] ;
let ver_matchesArray = [];

let score = 0
let ver_score = 0;
let shapesValue = {}
let current_round=1;

// Share variables
let shareTCopy = "DEMO: I won 0%25 off my first grocery order. See how much savings you can pack into an hour."
let shareCopy = "DEMO: I won 0 off my first grocery order. See how much savings you can pack into an hour."
//game variables
let isPlaying= false;
let shouldLoop= false;
let isUIOpen =false;
let wasPlaying = false;

let timeLeftDoms = document.querySelectorAll('.time-left');

const iniGridDom = () =>{
  const tempGrid = document.getElementById('MainGrid');
  tempGrid.innerHTML = '';
  domMatrix.forEach((el,i) => {
    let div = document.createElement("div");
    div.classList.add('cell')

    if(i>=domMatrix.length-7){
      div.classList.add('taken')
      div.classList.add('wall')
    }
    tempGrid.append(div)
  });
}

const changeInstructions = ()=>{
  // console.log(isMobile())
  // console.log([...document.querySelectorAll('.instructions .desktop')],[...document.querySelectorAll('.instructions .mobile')])
  if(isMobile()){
    [...document.querySelectorAll('.instructions .mobile')].forEach(el =>{
      el.classList.remove('hidden')
    });
    [...document.querySelectorAll('.instructions .desktop')].forEach(el =>{
      el.classList.add('hidden')
    });
  }else{
    [...document.querySelectorAll('.instructions .mobile')].forEach(el =>{
      el.classList.add('hidden')
    });
    [...document.querySelectorAll('.instructions .desktop')].forEach(el =>{
      el.classList.remove('hidden')
    });
  }
}


const initTimerOnCaseStudy = ()=>{
  let d = Date.now();
  LB.setCookie('dd_time',d,37500);
}

const addDummyLeaderboard = () =>{
  const lb_parents = document.querySelectorAll('.leaderboard');
  // console.log(lb_containers);
  [...lb_parents].forEach((lb_parent)=>{
    const lb_container = lb_parent.querySelector('.positions-container')
    lb_container.innerHTML="";
  for (let index = 0; index < 18; index++) {
    //console.log(result[index]);
    let temp_s= (18-index)*40000;
    let rank = temp_s>150000?temp_s>600000?'gold':'silver':'bronze';

    if(index==0){
      lb_parent.querySelector('.current-winner .rank-pos').innerHTML = '1st';
      lb_parent.querySelector('.current-winner .initial-lead').innerHTML = 'DD';
      lb_parent.querySelector('.current-winner .score-lead').innerHTML = Math.floor(temp_s);
    }else{
      const temp_div = document.createElement('div');
      temp_div.innerHTML = `
        <span class="rank-pos">${index+1}</span>
        <img src="/assets/images/${rank}.png" alt="">
        <span class="initial-lead">AAA</span>
        <span class="score-lead">${temp_s}</span>
      `

      temp_div.classList.add('lb-entry');

      lb_container.appendChild(temp_div);
    }
    
  }
  })
  
}

function updateLeaderboard(){
  // addDummyLeaderboard() //placeholder
  LB.getLeaderboard((result)=>{
    if(!result) return

    const lb_container = document.querySelector('.positions-container');
    lb_container.innerHTML="";
    for (let index = 0; index < result.length; index++) {

      // console.log(result[index]);
      let rank = result[index].score>150000?result[index].score>600000?'gold':'silver':'bronze';
      if(index==0){
        document.querySelector('.current-winner .rank-pos').innerHTML = '1st';
        document.querySelector('.current-winner .initial-lead').innerHTML = result[index].alias;
        document.querySelector('.current-winner .score-lead').innerHTML = Math.floor(result[index].score);
      }else{
        const temp_div = document.createElement('div');
        temp_div.innerHTML = `
          <span class="rank-pos">${index+1}</span>
          <img src="/assets/images/${rank}.png" alt="">
          <span class="initial-lead">${result[index].alias}</span>
          <span class="score-lead">${Math.floor(result[index].score)}</span>
        `

        temp_div.classList.add('lb-entry');
        lb_container.appendChild(temp_div);
      }
    }
  })
}

const resize = () =>{
  // console.log('resizing',isMobile());
  if(isMobile()){
    // console.log(screen.availHeight, screen.availWidth)
    if(screen.availHeight  > screen.availWidth){
      document.getElementById('landscape-error').classList.add('hidden');
     
      if(wasPlaying){
        isPlaying=true;
      }
    
    }else{
      document.getElementById('landscape-error').classList.remove('hidden');
      wasPlaying = isPlaying;
      isPlaying=false;
    }

    if(isIOS()){
      if(window.innerWidth > window.innerHeight) {
        document.getElementById('landscape-error').classList.remove('hidden');
        wasPlaying = isPlaying;
        isPlaying=false;
      } else {
        document.getElementById('landscape-error').classList.add('hidden');
        if(wasPlaying){
          isPlaying=true;
        }
      }
    }
  }
}
//Resize window
window.onresize = function (event) {
  resize();
}



window.onload = () =>{
  //Check if is returning user
  initTimerOnCaseStudy();
  changeInstructions();
  resize();
  LB.isNewUser((isNew,u_i,u_em,u_scor,u_rank)=>{
    document.querySelector('.leaderboard .current-user').classList.add('hidden');
    document.querySelector('#desktop-game-ui .leaderboard .current-user').classList.add('hidden');
    // if(isNew){
    //   // console.log('new user');
    //   document.querySelector('.leaderboard .current-user').classList.add('hidden');
    //   document.querySelector('#desktop-game-ui .leaderboard .current-user').classList.add('hidden');
    // }else{
    //   //UPDATE LEADERBOARD
    //   // console.log('checking user',u_i+u_em+u_scor+u_rank);
    //   document.querySelector('.leaderboard .current-user').classList.remove('hidden');
    //   document.querySelector('.leaderboard .current-user .rank-pos').innerHTML = u_rank?u_rank:'??';
    //   document.querySelector('.leaderboard .current-user .initial-lead').innerHTML = u_i?u_i:'AAA';
    //   document.querySelector('.leaderboard .current-user .score-lead').innerHTML = u_scor?Math.floor(u_scor):'AAA';
      
    //   //desktop UI leaderboard
    //   document.querySelector('#desktop-game-ui .leaderboard .current-user').classList.remove('hidden');
    //   document.querySelector('#desktop-game-ui .leaderboard .current-user .rank-pos').innerHTML = u_rank?u_rank:'??';
    //   document.querySelector('#desktop-game-ui .leaderboard .current-user .initial-lead').innerHTML = u_i?u_i:'AAA';
    //   document.querySelector('#desktop-game-ui .leaderboard .current-user .score-lead').innerHTML = u_scor?Math.floor(u_scor):'AAA';
    // }
  });

  // Initialize leaderboard
  // updateLeaderboard();
  addDummyLeaderboard();

  iniGridDom();
  titleScreenMusic.play();
  let squares = Array.from(document.querySelectorAll('.cell'))
  const scoreDisplay = document.querySelectorAll('.score')
  const playNowBtn = document.querySelector('#play-now-button')
  const preGameStartBtn = document.querySelector('#pre-game-start-btn')
  const width = 7
  let nextRandom = 0
  let timerId

  const typoOfProduct = [
    'bread',
    'cheese',
    'broccoli',
    'strawberry',
    'apple',
    'peach'
  ]

  //The Tetrominoes

  const PRODUCTS = {
    //4 long line
    bread: {'shape':[
        [width,width+1,width+2,width+3],
        [1,width+1,width*2+1,width*3+1],
        [width,width+1,width+2,width+3],
        [1,width+1,width*2+1,width*3+1],
      ],
      'sprites':[
        ['baguette_0_0','baguette_1_0','baguette_2_0','baguette_3_0'],
        ['baguette_0_90','baguette_1_90','baguette_2_90','baguette_3_90'],
        ['baguette_0_180','baguette_1_180','baguette_2_180','baguette_3_180'],
        ['baguette_0_270','baguette_1_270','baguette_2_270','baguette_3_270'],
      ],
      'val':100,
      'type':'bread'
    },
    //Square Shape
    cheese:{'shape':[
        [0,1,width,width+1],
        [0,1,width,width+1],
        [0,1,width,width+1],
        [0,1,width,width+1],
      ],
      'sprites':[
        ['cheese_0_0','cheese_1_0','cheese_2_0','cheese_3_0'],
        ['cheese_0_90','cheese_1_90','cheese_2_90','cheese_3_90'],
        ['cheese_0_180','cheese_1_180','cheese_2_180','cheese_3_180'],
        ['cheese_0_270','cheese_1_270','cheese_2_270','cheese_3_270'],
      ],
      'val':120,
      'type':'cheese'
    },
    //Square Shape
    donut:{'shape':[
        [0,1,width,width+1],
        [0,1,width,width+1],
        [0,1,width,width+1],
        [0,1,width,width+1],
      ],
      'sprites':[
        ['donut_0_0','donut_1_0','donut_2_0','donut_3_0'],
        ['donut_0_90','donut_1_90','donut_2_90','donut_3_90'],
        ['donut_0_180','donut_1_180','donut_2_180','donut_3_180'],
        ['donut_0_270','donut_1_270','donut_2_270','donut_3_270'],
      ],
      'val':120,
      'type':'donut'
    },
    //T shape
    broccoli:{'shape':[
        [1,width,width+1,width+2],
        [1,width+1,width+2,width*2+1],
        [width,width+1,width+2,width*2+1],
        [1,width,width+1,width*2+1]
      ],
      'sprites':[
        ['broccoli_0_180','broccoli_1_180','broccoli_2_180','broccoli_3_180'],
        ['broccoli_0_90','broccoli_1_90','broccoli_2_90','broccoli_3_90'],
        ['broccoli_0_0','broccoli_1_0','broccoli_2_0','broccoli_3_0'],
        ['broccoli_0_270','broccoli_1_270','broccoli_2_270','broccoli_3_270'],
      ],
      'val':140,
      'type':'broccoli'
    },
    // T Shape
    apple:{'shape':[
      [1,width,width+1,width+2],
      [1,width+1,width+2,width*2+1],
      [width,width+1,width+2,width*2+1],
      [1,width,width+1,width*2+1]
    ],
      'sprites':[
        ['gApple_0_0','gApple_0_0','gApple_0_0','gApple_0_0'],
        ['gApple_0_90','gApple_0_90','gApple_0_90','gApple_0_90'],
        ['gApple_0_180','gApple_0_180','gApple_0_180','gApple_0_180'],
        ['gApple_0_270','gApple_0_270','gApple_0_270','gApple_0_270'],
      ],
      'val':140,
      'type':'apple'
    },
    // L Shape
    strawberry:{'shape':[
        [1, width,width+1],
        [0, width,width+1],
        [0,1,width],
        [0,1,width+1],
      ],
      'sprites':[
        ['strawberry_0_0','strawberry_0_180','strawberry_0_90','','strawberry_0_0'],
        ['strawberry_0_270','strawberry_0_180','strawberry_0_90','strawberry_0_90'],
        ['strawberry_0_270','strawberry_0_0','strawberry_0_180','strawberry_0_180'],
        ['strawberry_0_270','strawberry_0_0','strawberry_0_90','strawberry_0_270'],
      ],
      'val':130,
      'type':'strawberry'
    },

    // L Shape
    shrimp:{'shape':[
        [1, width,width+1],
        [0, width,width+1],
        [0,1,width],
        [0,1,width+1],
      ],
      'sprites':[
        ['shrimp_0_90','shrimp_1_90','shrimp_2_90',],
        ['shrimp_0_180','shrimp_1_180','shrimp_2_180'],
        ['shrimp_0_270','shrimp_1_270','shrimp_2_270'],
        ['shrimp_0_0','shrimp_1_0','shrimp_2_0'],
      ],
      'val':130,
      'type':'shrimp'
    },

    //2 long line
    porkChop: {'shape':[
        [width,width+1],
        [1,width+1],
        [width,width+1],
        [1,width+1],
      ],
      'sprites':[
        ['porkChop_0_0','porkChop_1_0'],
        ['porkChop_0_90','porkChop_1_90'],
        ['porkChop_0_180','porkChop_1_180'],
        ['porkChop_0_270','porkChop_1_270'],
      ],
      'val':50,
      'type':'porkChop'
    },
    //2 long line
    peach: {'shape':[
        [width,width+1],
        [1,width+1],
        [width,width+1],
        [1,width+1],
      ],
      'sprites':[
        ['peach_0_0','peach_1_0'],
        ['peach_0_90','peach_1_90'],
        ['peach_0_180','peach_1_180'],
        ['peach_0_270','peach_1_270'],
      ],
      'val':50,
      'type':'peach'
    },
    //3 long line
      milk: {'shape':[
          [width,width+1,width+2],
          [1,width+1,width*2+1],
          [width,width+1,width+2],
          [1,width+1,width*2+1],
        ],
        'sprites':[
          ['milk_0_0','milk_1_0','milk_2_0'],
          ['milk_0_90','milk_1_90','milk_2_90'],
          ['milk_0_180','milk_1_180','milk_2_180'],
          ['milk_0_270','milk_1_270','milk_2_270'],
        ],
        'val':50,
        'type':'milk'
      },
    //3 long line
    corn: {'shape':[
        [width,width+1,width+2],
        [1,width+1,width*2+1],
        [width,width+1,width+2],
        [1,width+1,width*2+1],
      ],
      'sprites':[
        ['corn_0_0','corn_1_0','corn_2_0'],
        ['corn_0_90','corn_1_90','corn_2_90'],
        ['corn_0_180','corn_1_180','corn_2_180'],
        ['corn_0_270','corn_1_270','corn_2_270'],
      ],
      'val':50,
      'type':'corn'
    },
  }
  const lTetromino = [
    [1, width+1, width*2+1, 2],
    [width, width+1, width+2, width*2+2],
    [1, width+1, width*2+1, width*2],
    [width, width*2, width*2+1, width*2+2]
  ]

  const zTetromino = [
    [0,width,width+1,width*2+1],
    [width+1, width+2,width*2,width*2+1],
    [0,width,width+1,width*2+1],
    [width+1, width+2,width*2,width*2+1]
  ]

  const tTetromino = [
    [1,width,width+1,width+2],
    [1,width+1,width+2,width*2+1],
    [width,width+1,width+2,width*2+1],
    [1,width,width+1,width*2+1]
  ]

  const oTetromino = [
    [0,1,width,width+1],
    [0,1,width,width+1],
    [0,1,width,width+1],
    [0,1,width,width+1]
  ]

  const iTetromino = [
    [1,width+1,width*2+1,width*3+1],
    [width,width+1,width+2,width+3],
    [1,width+1,width*2+1,width*3+1],
    [width,width+1,width+2,width+3]
  ]

  // const theTetrominoes = [lTetromino, zTetromino, tTetromino, oTetromino, iTetromino]
  const theTetrominoes = [
    PRODUCTS['bread'],
    PRODUCTS['strawberry'],
    PRODUCTS['cheese'],
    PRODUCTS['broccoli'],
    PRODUCTS['peach'],
    PRODUCTS['milk'],
    PRODUCTS['donut'],
    PRODUCTS['corn'],
    PRODUCTS['apple'],
    PRODUCTS['shrimp'],
    PRODUCTS['porkChop'],
  ]
  // const theTetrominoes = [PRODUCTS['L']]

  let currentPosition = 2
  let currentRotation = 0

  // console.log(theTetrominoes[0].shape[0])

  //randomly select a Tetromino and its first rotation
  let random = Math.floor(Math.random()*(theTetrominoes.length - storedProducts))
  let currentObj = theTetrominoes[random];
  let current = theTetrominoes[random].shape[currentRotation]
  let randomId = Date.now();

  //draw the Tetromino
  function draw() {
    current.forEach((index, i) => {
      squares[currentPosition + index].classList.add('tetromino')
      squares[currentPosition + index].classList.add(randomId)
      squares[currentPosition + index].classList.add(currentObj.type)
      squares[currentPosition + index].setAttribute('data-sprite',currentObj.sprites[currentRotation][i])
      squares[currentPosition + index].style.backgroundImage=(`url(/assets/sprites/${currentObj.sprites[currentRotation][i]}.png)`)
      // console.log(currentObj);
    })
  }

  //undraw the Tetromino
  function undraw() {
    current.forEach(index => {
      squares[currentPosition + index].classList.remove('tetromino')
      squares[currentPosition + index].classList = ['cell'];
      squares[currentPosition + index].removeAttribute("data-sprite");
      squares[currentPosition + index].style.backgroundImage = '';
      //squares[currentPosition + index].style.backgroundColor = ''

    })
  }

  //assign functions to keyCodes
  function control(e) {
    if(e.keyCode === 77){
      titleScreenMusic.pause()
      gamePlayMusic.pause()
    }
    if(!isPlaying || isUIOpen){
      return
    }
    if(e.keyCode === 37) {
      moveLeft()
    } else if (e.keyCode === 38 || e.keyCode === 32) {
      rotate()
    } else if (e.keyCode === 39) {
      moveRight()
    } else if (e.keyCode === 40) {
      moveDown()
    }
  }

  document.addEventListener('keyup', control)

  document.addEventListener('tap',function (e){
    // alert('tap');
    if(!isPlaying || isUIOpen){
      return
    }
    rotate()
  });
  document.addEventListener('longtap',function (e){
    // alert('tap');
    titleScreenMusic.pause();
    gamePlayMusic.pause();
  });

  document.addEventListener('swipedown',function (e){
    // alert('swipeUp')
    if(!isPlaying || isUIOpen){
      return
    }
    moveDown()
  });

  document.addEventListener('swipeleft',function (e){
    // alert('swipeUp')
    if(!isPlaying || isUIOpen){
      return
    }
    moveLeft()
  });

  document.addEventListener('swiperight',function (e){
    // alert('swipeUp')
    if(!isPlaying || isUIOpen){
      return
    }
    moveRight();
  });

  //move down function
  function moveDown() {
    if(!isPlaying || isUIOpen){
      return
    }
    fallingSound.play();
    //const rm = removePairs();
   // if(rm.length<=0){
      undraw()
      currentPosition += width
      if(!canMoveDown()){
        currentPosition-= width
      }
      draw()
      freeze()
    //}
  }



  //freeze function
  function freeze() {
    let shouldFreeze = false;
    if(current.some(index => squares[currentPosition + index + width].classList.contains('taken'))) {
      let findPair = false;
      let pairId = null;
      const setOfPairs = new Set();
      for (let i = 0; i < current.length; i++) {
        const element = current[i];
        // console.log("===============")
        // console.log(squares[currentPosition + i + width],squares[currentPosition + i])
        // console.log(currentObj.type, randomId)
        // console.log("===============")

        if(squares[currentPosition + element + width].classList.contains(currentObj.type) && !squares[currentPosition + element + width].classList.contains(randomId)){
          // console.log("find pair")

          //Save pairs in array if it isn't in there, because it can connect more than one element.

          const pairEl = squares[currentPosition + element + width];
          pairId = [...pairEl.classList].filter((value) => !['cell','taken',currentObj.type,'tetromino'].includes(value))
          setOfPairs.add(pairId)
          findPair = true;
          // break;
        }

        // Check horizontal match
        if((squares[currentPosition + element + 1].classList.contains(currentObj.type)) && !squares[currentPosition + element + 1].classList.contains(randomId)){
          if(!isAtRight()){
            // console.log(squares[currentPosition + element + 1])
            const pairEl = squares[currentPosition + element + 1];
            pairId = [...pairEl.classList].filter((value) => !['cell','taken',currentObj.type,'tetromino'].includes(value))
            setOfPairs.add(pairId)
            findPair = true;
            // break;
          }
        }
        if((squares[currentPosition + element - 1].classList.contains(currentObj.type)) && !squares[currentPosition + element - 1].classList.contains(randomId)){
          if(!isAtLeft()){
            // console.log(squares[currentPosition + element - 1])
            const pairEl = squares[currentPosition + element - 1];
            pairId = [...pairEl.classList].filter((value) => !['cell','taken',currentObj.type,'tetromino'].includes(value))
            setOfPairs.add(pairId)
            findPair = true;
            // break;
          }

        }
      }

      if(findPair){
        setOfPairs.forEach(p=>{
          current.forEach(index => squares[currentPosition + index].classList.add('remove'))
          let tempPairArray = document.getElementsByClassName(p);
          [...tempPairArray].forEach(el => el.classList.add('remove'))
          //current.forEach(index => squares[currentPosition + index].classList = ['cell'])
        })
        removePairs()
        addScore();
      }else{
        frezzeCellSound.play();
        current.forEach(index => squares[currentPosition + index].classList.add('taken'))
      }

      currentRotation = 0
      random = nextRandom
      nextRandom =  Math.floor(Math.random()*(theTetrominoes.length - storedProducts))
      randomId = Date.now();
      currentObj = theTetrominoes[random];
      current = theTetrominoes[random].shape[currentRotation]
      currentPosition = 2

      draw()
      increaseLevel();
      displayShape(theTetrominoes[nextRandom].type)
      gameOver()
    }

    if(shouldFreeze){
       //start a new tetromino falling

       shouldFreeze = false;
    }
  }

  function removePairs(){
    isPlaying=false;
    matchPairSound.play();

    setTimeout(()=>{

      const tempRemove = document.getElementsByClassName('remove');
      [...tempRemove].forEach(el => {
        el.classList = ['cell']
        el.removeAttribute("data-sprite");
        el.style.backgroundImage = '';
      })
      isPlaying = true;
    },400)
  }

  //move the tetromino left, unless is at the edge or there is a blockage
  function moveLeft() {
    undraw()
    const isAtLeftEdge = current.some(index => (currentPosition + index) % width === 0)
    if(!isAtLeftEdge) currentPosition -=1
    if(current.some(index => squares[currentPosition + index].classList.contains('taken'))) {
      currentPosition +=1
    }
    draw()

    moveSound.play();

  }

  //move the tetromino right, unless is at the edge or there is a blockage
  function moveRight() {
    undraw()
    const isAtRightEdge = current.some(index => (currentPosition + index) % width === width -1)
    if(!isAtRightEdge) currentPosition +=1
    if(current.some(index => squares[currentPosition + index].classList.contains('taken'))) {
      currentPosition -=1
    }
    draw()

    moveSound.play();
  }


  ///FIX ROTATION OF TETROMINOS A THE EDGE
  function isAtRight() {
    return current.some(index=> (currentPosition + index + 1) % width === 0)
  }

  function isAtLeft() {
    return current.some(index=> (currentPosition + index) % width === 0)
  }

  function checkRotatedPosition(P){
    if(!current)
      return;

    P = P || currentPosition       //get current position.  Then, check if the piece is near the left side.
    if ((P+1) % width < 4) {         //add 1 because the position index can be 1 less than where the piece is (with how they are indexed).
      if (isAtRight()){            //use actual position to check if it's flipped over to right side
        currentPosition += 1    //if so, add one to wrap it back around
        checkRotatedPosition(P) //check again.  Pass position from start, since long block might need to move more.
        }
    }
    else if (P % width <= 5) {
      if (isAtLeft()){
        currentPosition -= 1
      checkRotatedPosition(P)
      }
    }
  }
  function canRotate(){
    const temCurrent = theTetrominoes[random].shape[currentRotation];
    let isValid = true;
    // theTetrominoes[random].shape[currentRotation]
    if(temCurrent){
      temCurrent.forEach(index => {
        if(squares[currentPosition + index]){
          if(squares[currentPosition + index].classList.contains('taken')){
            isValid = false;
          }
        }else{
          isValid = false;
        }
      });
    }else{
      isValid = false;
    }
    return isValid;
  }

  function canMoveDown(){
    const temCurrent = theTetrominoes[random].shape[currentRotation];
    let isValid = true;
    // theTetrominoes[random].shape[currentRotation]
    if(temCurrent){
      temCurrent.forEach(index => {
        if(squares[currentPosition + index]){
          if(squares[currentPosition + index].classList.contains('taken')){
            isValid = false;
          }
        }else{
          isValid = false;
        }
      });
    }else{
      isValid = false;
    }
    
    return isValid;
  }

  //rotate the tetromino
  function rotate() {
    // Check if index is inside the array, if not, then it doesnt rotate.
    rotateSound.play();
    undraw()
    // console.log(currentRotation,current.length)
    currentRotation++
    // console.log(currentRotation,current.length)
    if(currentRotation === 4 ) { //if the current rotation gets to 4, make it go back to 0
      currentRotation = 0
    }else if(currentRotation === -1){
      currentRotation = 3
    }
    if(!canRotate()){
      // console.log('cant')
      currentRotation --;
    }else{
      // console.log('ok')
    }
    if(currentRotation === 4 ) { //if the current rotation gets to 4, make it go back to 0
      currentRotation = 0
    }else if(currentRotation === -1){
      currentRotation = 3
    }
    // var tempCurrent = current;
    current = theTetrominoes[random].shape[currentRotation]
    checkRotatedPosition()
    draw()
  }

  const increaseLevel = ()=>{
    current_round++;
    if(current_round%3==0){
      if(gameSpeed>150){
        if(gameSpeed>600){
          gameSpeed-=200;
        }else if(gameSpeed>200){
          gameSpeed-=15;
        }else{
          gameSpeed-=5;
        }
      }
      if(storedProducts>0 && current_round%8==0){
        storedProducts--;
      }
      // console.log('increase Speed: '+gameSpeed, current_round);
    }
  }



  // // show up-next tetromino in mini-grid display
  // const displaySquares = document.querySelectorAll('.mini-grid div')
  // const displayWidth = 4
  // const displayIndex = 0
  // //the Tetrominos without rotations
  // const upNextTetrominoes = [
  //   [displayWidth,displayWidth+1,displayWidth+2,displayWidth+3],
  //   [0,1,displayWidth,displayWidth+1],
  //   [1,displayWidth,displayWidth+1,displayWidth+2],
  //   [0,1,displayWidth],
  // ]

  //display the shape in the mini-grid display
  // TODO: Replace this for just image
  function displayShape(nextProduct) {
    document.querySelector('.next-shape img').setAttribute('src',`/assets/images/${nextProduct}.png`);
  }

  //add score
  function addScore() {
    if(theTetrominoes.length<=0)
      return
    let tempScore = (currentObj.val*current_round) + ((currentObj.val%11)*(current_round%10))
    score +=tempScore;
    // console.log(currentObj.type, tempScore)
    matchesArray.push({shape: currentObj.type, Round:current_round});

    [...scoreDisplay].forEach(element => {
      element.innerHTML = Math.floor(score);
    });

    // TODO: Add class used to row, and if used and notaken then remove row and put it on top
    // scoreDisplay.innerHTML = score;
    // for (let i = 0; i < 199; i +=width) {
    //   const row = [i, i+1, i+2, i+3, i+4, i+5, i+6, i+7, i+8, i+9]
    //   if(row.every(index => squares[index].classList.contains('taken'))) {
    //     score +=10
    //     scoreDisplay.innerHTML = score
    //     row.forEach(index => {
    //       squares[index].classList.remove('taken')
    //       squares[index].classList.remove('tetromino')
    //       squares[index].style.backgroundColor = ''
    //     })
    //     const squaresRemoved = squares.splice(i, width)
    //     squares = squaresRemoved.concat(squares)
    //     squares.forEach(cell => grid.appendChild(cell))
    //   }
    // }
  }



  //game over
  function gameOver() {
    if(current.some(index => squares[currentPosition + index].classList.contains('taken'))||current.some(index => squares[currentPosition + index+width].classList.contains('taken'))) {
      gamePlayMusic.fade(0.05, 0,300);
      // titleScreenMusic.play();

      let prizeLvl = "bronze"
      if(score> 150000){ // should be 150000
        prizeLvl = "silver"
      }
      if(score> 600000){  // should be 600000
        prizeLvl = "gold"
      }

      let prizeLvlCopy = ""
      let discountCopy = ""
      switch(prizeLvl){
        case 'bronze':
          prizeLvlCopy = 'YOU WON BRONZE!';
          discountCopy =  '0% off up to $0 on your first Albertsons order.'
          shareTCopy = "DEMO: I won 0%25 off my first grocery order. See how much savings you can pack into an hour."
          shareCopy = "DEMO: I won 0 off my first grocery order. See how much savings you can pack into an hour."
        break;
        case 'silver':
          prizeLvlCopy = 'YOU WON SILVER!';
          discountCopy = '0% off up to $0 on your next Albertsons order.';
          document.querySelector('.score-screen .score-screen-btn').innerText = "CLAIM PRIZE NOW";
          document.querySelector('.submit-title').innerText = "CLAIM PRIZE";
          shareTCopy = "DEMO: I won 0%25 off my next grocery order. See how much savings you can pack into an hour."
          shareCopy = "DEMO: I won 0% off my next grocery order. See how much savings you can pack into an hour."

        break;
        case 'gold':
          prizeLvlCopy = 'YOU WON GOLD!';
          discountCopy = '0% off up to $0 on your next Albertsons order.';
          document.querySelector('.score-screen .score-screen-btn').innerText = "CLAIM PRIZE NOW";
          document.querySelector('.submit-title').innerText = "CLAIM PRIZE";
          shareTCopy = "DEMO: I won 0%25 off my next grocery order. See how much savings you can pack into an hour."
          shareCopy = "DEMO: I won 0% off my next grocery order. See how much savings you can pack into an hour."
        break;
      }


      [... document.querySelectorAll('.leaderboard-position')].forEach(el =>{
        el.setAttribute('src',`/assets/images/${prizeLvl}.png`);
      });

      [... document.querySelectorAll('.prize-lvl')].forEach(el =>{
        el.innerHTML = prizeLvlCopy;
      });

      [... document.querySelectorAll('.prize-copy')].forEach(el =>{
        el.innerHTML = discountCopy;
      });

      //pause game
      // clearInterval(timerId)
      cancelAnimationFrame(timerId);

      isPlaying = false;
      shouldLoop = false;
      document.getElementById('desktop-game-ui').classList.add('hidden')

      
      document.querySelector('.game-ui').classList.add('hidden')
      document.querySelector('#game-container').classList.add('hidden')
      document.querySelector('.gameover-ui').classList.add(prizeLvl)
      document.querySelector('.gameover-ui').classList.remove('hidden')
      //show UI
      if(runnedOutOfTime){
        if(!submited){

          document.querySelector('.timeout-screen').classList.remove('hidden') 
          const all_timer = document.querySelectorAll('.time-left-note');
          [...all_timer].forEach((el)=>{
            el.classList.add('hidden');
          });
        }else{
          document.querySelector('.submit-confirmation-screen').classList.remove('hidden') 
          document.querySelector('.submit-confirmation-screen .confirmation-copy').innerHTML = "You’ve already submitted a score."
          document.querySelector('.submit-confirmation-screen .for-fun-label').innerHTML = "You’ve already played 1-hour for a prize. You can keep playing for fun"
          document.querySelector('.submit-confirmation-screen .for-fun-label').classList.remove('hidden')
          document.querySelector('.submit-confirmation-screen .legal-notice').classList.add('hidden')
        }

      }else{
        document.querySelector('.score-screen').classList.remove('hidden')
        
      }

      document.querySelector('#footer .in-game').classList.add('hidden')
      document.querySelector('#footer .pos-game').classList.remove('hidden')

    }
  }

  //------ UI -----//

  //START button
  playNowBtn.addEventListener('click', () => {
    if(firstTime){
      document.getElementById('brand-logos').classList.add('playing')
      document.querySelector('.pre-game').classList.remove('hidden')
    }else{
      startGame()
    }
  })
  preGameStartBtn.addEventListener('click', ()=>{
    startGame()
  })

  //Play Again function
  const playAgain = ()=>{
    titleScreenMusic.play();
    //document.querySelector('.game-ui').classList.add('hidden')
    document.querySelector('#game-container').classList.remove('hidden')
    document.querySelector('.gameover-ui').classList = ['gameover-ui'];
    document.querySelector('.gameover-ui').classList.add('hidden')
    document.querySelector('.score-screen').classList.add('hidden')
    document.querySelector('.timeout-screen').classList.add('hidden')
    document.querySelector('.submit-screen').classList.add('hidden')
    document.querySelector('.submit-confirmation-screen').classList.add('hidden')

    document.querySelector('#footer .in-game').classList.add('hidden')
    document.querySelector('#footer .pos-game').classList.add('hidden')

    document.getElementById('game-container').classList.add('onHold')
    document.getElementById('brand-logos').classList.remove('playing')
    document.querySelector('.landing').classList.remove('hidden')
    document.querySelector('.pre-game').classList.add('hidden')

    // document.querySelector('.game-ui').classList.add('hidden')
    // document.querySelector('#footer .in-game').classList.remove('hidden')

    document.getElementById('bag-animation').classList.add('onHold')
    document.getElementById('bag-animation').classList.remove('hidden')

    iniGridDom();
    squares = Array.from(document.querySelectorAll('.cell'));

    frame = 0;
    gameSpeed = 900; //duration of cycle in ms.
    storedProducts = 6;

    // const domMatrix =  Array(width*STAGE_HEIGHT).fill([0,'clear']);

    // score variables
    matchesArray = [] ;
    ver_matchesArray = [];

    currentPosition = 2
    currentRotation = 0

    //console.log(theTetrominoes[0].shape[0])

    //randomly select a Tetromino and its first rotation
    random = Math.floor(Math.random()*(theTetrominoes.length - storedProducts))
    currentObj = theTetrominoes[random];
    current = theTetrominoes[random].shape[currentRotation]
    randomId = Date.now();

    score = 0;
    [...scoreDisplay].forEach(element => {
      element.innerHTML = Math.floor(score);
    });

    ver_score = 0;
    shapesValue = {}
    current_round=1;
    isPlaying= false;
    shouldLoop = false;
    isUIOpen =false;


    nextRandom = 0;
    timerId = null;
  }

  const checkTimer = ()=>{
    const ct = LB.getTimeForUser();
    const current = Date.now();
    const remain = 3600000 - (current-ct);
    // console.log(remain);'
    if(remain>0){
      var dr =  new Date(remain);
      var m = dr.getMinutes();
      var s = dr.getSeconds();
      // console.log(dr,remain);
      [...timeLeftDoms].forEach(el =>{
        el.innerHTML = `${m>10?m:'0'+m}:${s>10?s:'0'+s}`
      })
    }else{
      [...timeLeftDoms].forEach(el =>{
        el.innerHTML = `00:00`
      })
      runnedOutOfTime = false;
    }
    
    // console.log(`00:${m>10?m:'0'+m}:${s>10?s:'0'+s}`);

  }
  //StartGame function
  const startGame = ()=>{
    var cookied = LB.getCookie("game_session");
    if (!cookied) {
      console.log("new game")
      LB.startGame();
    }else{
      console.log("already playing")
    }

    if(!isMobile()){
      document.getElementById('desktop-game-ui').classList.remove('hidden')
    }

    document.getElementById('game-container').classList.remove('onHold')
    document.getElementById('brand-logos').classList.add('playing')
    document.querySelector('.landing').classList.add('hidden')
    document.querySelector('.pre-game').classList.add('hidden')

    document.querySelector('.game-ui').classList.remove('hidden')
    document.querySelector('#footer .in-game').classList.remove('hidden')

    document.getElementById('bag-animation').classList.remove('onHold')
    setTimeout(()=>{
      document.getElementById('bag-animation').classList.add('hidden')
    }, 600)

    if (timerId) {
      // clearInterval(timerId)
      cancelAnimationFrame(timerId);
      timerId = null

    } else {
      // console.log("starting timmer");
      checkTimer();
      isPlaying = true;
      shouldLoop = true;
      gamePlayMusic.play();
      titleScreenMusic.fade(0.01,0,300)
      draw()
      // timerId = setInterval(moveDown, 1000)
      timerId = requestAnimationFrame(gameLoop);
  //

      nextRandom =  Math.floor(Math.random()*(theTetrominoes.length - storedProducts))
      displayShape(theTetrominoes[nextRandom].type)
    }
  }

  function gameLoop() {
    const currentTime = Date.now();
    const deltaTime = currentTime - time;
    const deltaClock = currentTime - timer_time;

    if(deltaTime>gameSpeed){
      frame+=1;
      time = currentTime;
      moveDown();
      // console.log(frame);
    }
    if(deltaClock>1000){
      timer_time = currentTime;
      checkTimer();
    }
    if(shouldLoop){
      requestAnimationFrame(gameLoop);
    }
  }

  //BEGIN splash page button
  const splashButton = document.getElementById('splash-btn');
  splashButton.addEventListener('click', () => {
    document.querySelector('.splash-banner').classList.add('hidden')

  })

  //OPEN HOW TO PLAY
  const howToPlayOpenBtns = document.querySelectorAll('.how-to-play-btn');
  [...howToPlayOpenBtns].forEach(el =>{
    el.addEventListener('click', ()=>{
      document.querySelector('.how-to-play').classList.remove('hidden')
      isUIOpen= true;
    })
  })

  //CLOSE HOW TO PLAY
  const howToPlayCloseBtn = document.getElementById('how-to-close-btn');
  howToPlayCloseBtn.addEventListener('click', () => {
    document.querySelector('.how-to-play').classList.add('hidden')
    isUIOpen= false;
  })

  //CLOSE PRE-GAME POPUP
  const pregameCloseBtn = document.getElementById('pregame-close-btn');
  pregameCloseBtn.addEventListener('click',()=>{
    document.querySelector('.pre-game').classList.add('hidden')
  })

  //GO TO SUBMIT SCORE SCREEN BUTTON
  const scoreScreenBtn = document.querySelectorAll('.score-screen-btn');
  [...scoreScreenBtn].forEach(el =>{
    el.addEventListener('click', ()=>{
      if(submited){
        document.querySelector('.score-screen').classList.add('hidden');
        document.querySelector('.timeout-screen').classList.add('hidden');
        document.querySelector('.submit-screen').classList.add('hidden');
        document.querySelector('.submit-confirmation-screen').classList.remove('hidden');
        document.querySelector('.high-score-note').classList.add('hidden');
      }else{
        document.querySelector('.score-screen').classList.add('hidden');
        document.querySelector('.submit-screen').classList.remove('hidden');
        document.querySelector('.timeout-screen').classList.add('hidden');
        document.querySelector('.high-score-note').classList.add('hidden');
        // document.querySelector('.email-notification-note').classList.remove('hidden');
      }
    })
  });

  //SUBMIT SCORE
  const scoreForm = document.getElementById('submition-form');
  scoreForm.addEventListener('submit',()=>{
    document.querySelector('.score-screen').classList.add('hidden');
    document.querySelector('.timeout-screen').classList.add('hidden');
    document.querySelector('.submit-screen').classList.add('hidden');
    document.querySelector('.submit-confirmation-screen').classList.remove('hidden');

    const temp_initials = document.getElementById('initials-input').value;
    const temp_email = document.getElementById('email').value;

    //POST-CAMPAIGN DEMO ONLY
    document.querySelector('.leaderboard .current-user').classList.remove('hidden');
    document.querySelector('.leaderboard .current-user .rank-pos').innerHTML = "85";
    document.querySelector('.leaderboard .current-user .initial-lead').innerHTML = temp_initials;
    document.querySelector('.leaderboard .current-user .score-lead').innerHTML = n_scor?Math.floor(n_scor):'AAA';

    document.querySelector('#desktop-game-ui .leaderboard .current-user').classList.remove('hidden');
    document.querySelector('#desktop-game-ui .leaderboard .current-user .rank-pos').innerHTML = n_rank?n_rank:'??';
    document.querySelector('#desktop-game-ui .leaderboard .current-user .initial-lead').innerHTML = n_i?n_i:'AAA';
    document.querySelector('#desktop-game-ui .leaderboard .current-user .score-lead').innerHTML = score?Math.floor(score):'000';

    // LB.stopGame(temp_initials,temp_email,score,matchesArray,(n_rank,n_i,n_scor)=>{
    //     // console.log('checking user',u_i+u_em+u_scor+u_rank);
    //     document.querySelector('.leaderboard .current-user').classList.remove('hidden');
    //     document.querySelector('.leaderboard .current-user .rank-pos').innerHTML = n_rank?n_rank:'??';
    //     document.querySelector('.leaderboard .current-user .initial-lead').innerHTML = n_i?n_i:'AAA';
    //     document.querySelector('.leaderboard .current-user .score-lead').innerHTML = n_scor?Math.floor(n_scor):'AAA';

    //     document.querySelector('#desktop-game-ui .leaderboard .current-user').classList.remove('hidden');
    //     document.querySelector('#desktop-game-ui .leaderboard .current-user .rank-pos').innerHTML = n_rank?n_rank:'??';
    //     document.querySelector('#desktop-game-ui .leaderboard .current-user .initial-lead').innerHTML = n_i?n_i:'AAA';
    //     document.querySelector('#desktop-game-ui .leaderboard .current-user .score-lead').innerHTML = n_scor?Math.floor(n_scor):'AAA';
    //     updateLeaderboard();
    // },()=>{     
    //   //Rejected out of time
    //   document.querySelector('.submit-confirmation-screen .confirmation-copy').innerHTML = "You’ve already submitted a score."
    //   document.querySelector('.submit-confirmation-screen .for-fun-label').innerHTML = "You’ve already played 1-hour for a prize. You can keep playing for fun"
    //   document.querySelector('.submit-confirmation-screen .for-fun-label').classList.remove('hidden')
    //   document.querySelector('.submit-confirmation-screen .legal-notice').classList.add('hidden')
    //   const all_timer = document.querySelectorAll('.time-left-note');
    //   [...all_timer].forEach((el)=>{
    //     el.classList.add('hidden');
    //   });
    //   runnedOutOfTime = true;
    //   submited = true;
    // });
  })

  //SHARE buttons
  const shareButtons = document.querySelectorAll('.share-button');
  [...shareButtons].forEach((el)=>{
    el.addEventListener('click', event => {
      if (navigator.share && isMobile()) {
        navigator.share({
          title: 'DEMO: In The Bag - Doordash x Alberstsons',
          text: shareCopy,
          url: window.location.href
        }).then(() => {
          console.log('Thanks for sharing!');
        })
        .catch(console.error);
      } else {
        // shareDialog.classList.add('is-open');
        //let shareCopy = `I just got ${Math.floor(score)} points and won a special discount on doordash`
        window.open(`https://twitter.com/intent/tweet?text=${shareTCopy}&url=${window.location.href}&via=DoorDash`, '_blank');
      }
    });
  });

  //PLAY AGAIN BUTTONS
  const playAgainBtns = document.querySelectorAll('.play-again-btn');
  [...playAgainBtns].forEach(el =>{
    el.addEventListener('click', ()=>{
     playAgain();
    })
  });

  //OPEN LEADERBOARD
  const leaderboardOpenBtns = document.querySelectorAll('.leaderboard-btn');
  [...leaderboardOpenBtns].forEach(el =>{
    el.addEventListener('click', ()=>{
      document.querySelector('.leaderboard').classList.remove('hidden')
      isUIOpen= true;
    })
  })

  //CLOSE LEADERBOARD
  const leaderboardCloseBtns = document.getElementById('leaderboard-close-btn');
  leaderboardCloseBtns.addEventListener('click', () => {
    document.querySelector('.leaderboard').classList.add('hidden')
    isUIOpen= false;
  })

  //OPEN LEGAL
  const legalOpenBtns = document.querySelectorAll('.terms-conditions-btn');
  [...legalOpenBtns].forEach(el =>{
    el.addEventListener('click', ()=>{
      // window.open('/terms-conditions.pdf', '_blank');
      document.querySelector('#terms-conditions').classList.remove('hidden')
      isUIOpen= true;
    })
  })

  //CLOSE LEGAL
  const legalCloseBtn = document.getElementById('legal-close-btn');
  legalCloseBtn.addEventListener('click', () => {
    document.querySelector('#terms-conditions').classList.add('hidden')
    isUIOpen= false;
  })



  //add lottie animation
  var animation = bodymovin.loadAnimation({
    container: document.getElementById('lottie-food'), // Required
    path: '/assets/animations/LotieComp.json', // Required
    renderer: 'svg', // Required
    loop: true, // Optional
    autoplay: true, // Optional
    name: "Hello World", // Name for future reference. Optional.
  })

  //mute audios if leave page/tab
     // Event Listeners
  window.onblur = (e) => {
    muteAll(true);
  }

  window.onfocus = (e) => {
    muteAll(false)
  }
}